"use client"

import { colors, sizes } from "@/ui/theme/theme"
import { menuNavigationClick } from "@/utils/gtm"
import styled from "@emotion/styled"
import { Box, Link, Menu } from "@mui/material"
import Image from "next/image"
import { useRouter } from "next/navigation"
import React, { useCallback, useState } from "react"
import { getNonUmbracoUrl, getUmbracoMediaUrl } from "utils"
import { transformProperties } from "utils/simplifyData"
import CarouselItems from "../../CarouselItemsImageAndText"
import MegaMenuItem from "./MegaMenuItem"
import {
  StyledButton,
  StyledMenuItemWrapper,
  StyledTypo,
  StyledTypoInnerTitles,
} from "./styles"

const StyledListContainer = styled(Box)``

const StyledListContainerWrapper = styled(Box)`
  display: flex;
`
const StyledImageContainer = styled(Box)`
  width: 500px;
  height: 350px;
  position: relative;
  flex-shrink: 0;
  border-radius: ${sizes.borderRadius};
  overflow: hidden;
  margin-inline-end: 50px;
  margin-top: 50px;
`

const StyledLink = styled(Link)`
  text-decoration: none;
`
export const MegaMenuItems: React.FC<any> = ({ item, index, total }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const router = useRouter()
  const open = Boolean(anchorEl)
  const id = open ? "mega-menu-popover" : undefined
  const { title, menuRightArea, menuLeftArea, image, carouselItems, link } =
    transformProperties(item.properties)
  const rightMenuTitle = transformProperties(
    menuRightArea?.blocks[0]?.properties,
  ).title?.value
  const leftMenuTitle = transformProperties(menuLeftArea?.blocks[0]?.properties)
    .title?.value
  const rightMenuLinks = transformProperties(
    menuRightArea?.blocks[0]?.properties,
  ).links?.links
  const leftMenuLinks = transformProperties(menuLeftArea?.blocks[0]?.properties)
    .links?.links
  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleItemClick = (href: string) => {
    handleClose()
    router.push(getNonUmbracoUrl(href))
  }

  const sendMenuEvent = (itemName: string, categoryName?: string) => {
    menuNavigationClick({
      menuType: "תפריט עליון",
      menuCategory1: itemName,
      menuCategory2: categoryName,
    })
  }
  return (
    <StyledMenuItemWrapper className={item.class ? item.class.join(" ") : ""}>
      {(menuRightArea && menuRightArea?.blocks.length > 0) ||
      (menuLeftArea && menuLeftArea.blocks.length > 0) ? (
        <>
          <StyledButton
            variant="ghost"
            id={id}
            aria-controls={open ? "mega-menu-popover" : undefined}
            aria-describedby={id}
            onClick={handleClick}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            tabIndex={index}
          >
            <StyledTypo
              variant="h6"
              color={colors.black}
              className={open ? "active" : undefined}
            >
              {title?.value}
            </StyledTypo>
          </StyledButton>
          <Menu
            id={id}
            aria-labelledby={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            sx={{
              "& .MuiMenu-paper": {
                minHeight: "450px",
                borderEndEndRadius: "45px",
                borderEndStartRadius: "45px",
                minWidth: "340px",
                width: "auto",
                marginTop: "20px",
              },
            }}
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "50px",
                marginBottom: "50px",
              }}
            >
              {(rightMenuTitle || leftMenuTitle) && (
                <StyledListContainerWrapper>
                  <StyledTypoInnerTitles
                    variant="h6"
                    color={colors.red}
                    fontWeight={700}
                    marginBottom={4}
                  >
                    {rightMenuTitle}
                  </StyledTypoInnerTitles>
                  <StyledTypoInnerTitles
                    variant="h6"
                    color={colors.red}
                    fontWeight={700}
                    marginBottom={4}
                  >
                    {leftMenuTitle}
                  </StyledTypoInnerTitles>
                </StyledListContainerWrapper>
              )}

              <StyledListContainerWrapper>
                <StyledListContainer>
                  {rightMenuLinks &&
                    rightMenuLinks.length > 0 &&
                    rightMenuLinks?.map((child: any, index: number) => {
                      const currIndex = index
                      const itemsAmount = menuRightArea?.blocks?.length

                      return (
                        <MegaMenuItem
                          key={`${child[0]?.menuName}-${index}`}
                          item={child || ""}
                          outerIndex={currIndex}
                          outerChildren={itemsAmount}
                          handleItemClick={(href, buttonText) => {
                            sendMenuEvent(buttonText ?? "", title?.value)
                            handleItemClick(href)
                          }}
                        />
                      )
                    })}
                </StyledListContainer>
                <StyledListContainer>
                  {leftMenuLinks &&
                    leftMenuLinks.length > 0 &&
                    leftMenuLinks?.map((child: any, index: number) => {
                      const currIndex = index
                      const itemsAmount = menuRightArea?.blocks?.length
                      return (
                        <MegaMenuItem
                          key={`${child[0]?.menuName}-${index}`}
                          item={child || ""}
                          outerIndex={currIndex}
                          outerChildren={itemsAmount}
                          handleItemClick={(href, buttonText) => {
                            sendMenuEvent(buttonText ?? "", title?.value)
                            handleItemClick(href)
                          }}
                        />
                      )
                    })}
                </StyledListContainer>
              </StyledListContainerWrapper>
            </Box>
            <StyledImageContainer>
              <Image
                src={getUmbracoMediaUrl(image?.mediaItems[0]?.url)}
                alt={rightMenuTitle}
                fill
              />
            </StyledImageContainer>
            {carouselItems?.blocks.length > 0 && (
              <CarouselItems data={carouselItems.blocks} />
            )}
          </Menu>
        </>
      ) : (
        <StyledLink
          href={getNonUmbracoUrl(link?.links?.[0]?.url)}
          onClick={(e) => {
            e.preventDefault() // Prevent default link behavior
            handleItemClick(link?.links?.[0]?.url)
            sendMenuEvent(title?.value)
          }}
        >
          <StyledTypo variant="h6" color={colors.black}>
            {title?.value}
          </StyledTypo>
        </StyledLink>
      )}
    </StyledMenuItemWrapper>
  )
}
